export default function useStyles() {
  return {
    textField: (theme) => ({
      '.MuiOutlinedInput-root': { padding: theme.spacing(2, 1, 2, 2) },
      '.MuiInputBase-input': { minHeight: 115, paddingRight: theme.spacing(2) },
      '& .MuiFormHelperText-root': {
        marginTop: theme.spacing(1),
      },
    }),
    clear: { position: 'absolute', right: 0, bottom: -28 },
  };
}
